export enum BookingPriceBuildingStateEnum {
    Unset = 0,
    Building = 1,
    Done = 2
}
